/* Gourmet House Noir · theme.js */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Drawers ---------- */
  var openDrawer = null;
  var lastFocus = null;

  function open(name) {
    var el = document.getElementById(name + '-drawer');
    if (!el) return false;
    if (openDrawer && openDrawer !== el) close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    openDrawer = el;
    var focusable = el.querySelector('[data-drawer-close], a, button, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
    return true;
  }

  function close() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    openDrawer = null;
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && theme.cartType === 'page') return;
      if (open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); closeSearch(); }
  });

  /* ---------- Search ---------- */
  var searchModal = $('#search-modal');
  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]') && searchModal) {
      e.preventDefault();
      close();
      searchModal.classList.add('is-open');
      document.body.classList.add('is-locked');
      var input = $('input[type="search"]', searchModal);
      if (input) setTimeout(function () { input.focus(); }, 40);
    }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  /* ---------- Header ---------- */
  var headerWrap = $('.site-header-wrapper');
  if (headerWrap) {
    var onScroll = function () { headerWrap.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Close desktop dropdowns when clicking elsewhere
  document.addEventListener('click', function (e) {
    $$('.nav-desktop details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* ---------- Announcement ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var val = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart API ---------- */
  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function renderCartDrawer(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('[data-cart-count-source]');
    if (countEl) updateCount(countEl.getAttribute('data-cart-count-source'));
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    var items = [{ id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1', 10) }];
    var props = {};
    formData.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v) props[m[1]] = v;
    });
    if (Object.keys(props).length) items[0].properties = props;

    var label = button ? button.querySelector('[data-label]') || button : null;
    var original = label ? label.textContent : '';
    if (button) { button.classList.add('is-loading'); if (label) label.textContent = theme.strings.adding; }

    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) { errorEl.textContent = ''; errorEl.classList.add('hidden'); }

    return fetchJSON(theme.routes.cartAdd + '.js', { items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (data) {
        if (theme.cartType === 'page') { window.location.href = theme.routes.cart; return; }
        renderCartDrawer(data.sections);
        open('cart');
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || theme.strings.error;
        if (errorEl) { errorEl.textContent = msg; errorEl.classList.remove('hidden'); }
        else { window.alert(msg); }
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); if (label) label.textContent = original; }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  // Cart drawer: quantity & remove
  function changeLine(line, quantity) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.setAttribute('data-cart-busy', 'true');
    return fetchJSON(theme.routes.cartChange + '.js', { line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (data) { renderCartDrawer(data.sections); })
      .catch(function (err) {
        window.alert((err && err.description) || theme.strings.error);
        if (inner) inner.removeAttribute('data-cart-busy');
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line-qty'), 10);
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (input.closest('[data-cart-page]')) {
      fetchJSON(theme.routes.cartChange + '.js', { line: line, quantity: qty }).then(function () { window.location.reload(); });
    } else {
      changeLine(line, qty);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line-remove'), 10);
    if (btn.closest('[data-cart-page]')) {
      fetchJSON(theme.routes.cartChange + '.js', { line: line, quantity: 0 }).then(function () { window.location.reload(); });
    } else {
      changeLine(line, 0);
    }
  });

  // Cart note (gift message)
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetchJSON(theme.routes.cartUpdate + '.js', { note: note.value });
    }, 500);
  });

  /* ---------- Product variants ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var button = form && form.querySelector('[type="submit"]');
    var buttonLabel = button && button.querySelector('[data-label]');
    var priceEl = root.querySelector('[data-product-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyBtn = document.querySelector('[data-sticky-submit]');
    var fieldsets = $$('[data-option-index]', root);

    function selected() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        var select = fs.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function find(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }

    function markAvailability(values) {
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = values.slice();
          test[idx] = input.value;
          var match = product.variants.find(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var values = selected();
      var variant = find(values);
      fieldsets.forEach(function (fs, idx) {
        var lbl = fs.querySelector('[data-selected-value]');
        if (lbl) lbl.textContent = values[idx] || '';
      });
      markAvailability(values);

      if (!variant) {
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = theme.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (stickyPrice) stickyPrice.innerHTML = variant.price_plain;
      if (button) button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      if (variant.media_id) {
        var media = root.querySelector('[data-media-id="' + variant.media_id + '"]');
        if (media && window.matchMedia('(max-width: 989px)').matches) {
          media.parentElement.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
        }
      }

      if (root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    // Mobile gallery dots
    var gallery = root.querySelector('.product__gallery');
    var dots = $$('.product__dots span', root);
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    // Sticky add to cart on mobile
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && button && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(button);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(button); else button.click();
      });
    }
  }

  $$('[data-product-root]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-root]', e.target).forEach(initProduct);
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
  });

  /* ---------- Collection: auto-submit sort & filters ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-autosubmit]');
    if (el && el.form) el.form.submit();
  });
})();
